import { useSyncExternalStore } from 'react'
import noop from 'lib/function/noop'
import { isVoiceInputSupported } from '../utils/audio'
import { isMicrophoneBlocked, subscribeToMicrophonePermission } from '../utils/microphonePermission'

function subscribeToNothing() {
  return noop
}

function getFalse() {
  return false
}

/** Whether this browser can record voice input right now: supported and not blocked by the user. */
export function useMicrophoneAvailability(): boolean {
  const isSupported = useSyncExternalStore(subscribeToNothing, isVoiceInputSupported, getFalse)
  const isBlocked = useSyncExternalStore(subscribeToMicrophonePermission, isMicrophoneBlocked, getFalse)
  return isSupported && !isBlocked
}
